import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import 'react-slidedown/lib/slidedown.css'
import Dropdown from '../../dropdown'
import { FormSelectYesNo } from '../formelements'
import config from '../../../config'

export function EnrolmentFormAuthorizations(props) {

  const [errors, setErrors] = useState({});

  const handleErrors = (nom, error) => {
    //console.log('error', nom, error)
    setErrors(error)
  }

  /* AUTORITZACIONS */
  const [authorizationsOpen, setAuthorizationsOpen] = useState(true);

  const toggleAuthorizationsOpen = () => {
    setAuthorizationsOpen(!authorizationsOpen);
  }

  const [authIntranet, setAuthIntranet ] = useState(false);
  const [authPublicacions, setAuthPublicacions ] = useState(false);
  const [authMaterial, setAuthMaterial ] = useState(false);
  const [authMaterialInicials, setAuthMaterialInicials ] = useState(false);
  const [authInternet, setAuthInternet ] = useState(false);

  const [authDretsImatge , setAuthDretsImatge ] = useState("1");

  const [authCompromis, setAuthCompromis ] = useState("0");
  const [authGDPR, setAuthGDPR ] = useState("0");
  const [authSortides, setAuthSortides ] = useState();
  const [authAMPA, setAuthAMPA ] = useState("0");
  const [authMedica, setAuthMedica] = useState("0");
  const [authParacetamol, setAuthParacetamol ] = useState("0");
  const [authGimnas, setAuthGimnas ] = useState("0");
  const [authReligio, setAuthReligio ] = useState(props.dadesEstudis.authReligio ||"0");
  const [authPortatils, setAuthPortatils ] = useState("0");
  const [authAbsentisme, setAuthAbsentisme] = useState("0");
  const [authAlternanca, setAuthAlternanca ] = useState("0");
  const [authResponsable, setAuthResponsable ] = useState("0");
  const [authRecursosDigitals, setAuthRecursosDigitals] = useState("0");

  const [dadesAutoritzacions, setDadesAutoritzacions] = useState({validat: false});

  const handleDadesAutoritzacions = (noError) => {
    let d = {
     "validat": noError,
  
    /* DADES AUTORITZACIONS */
    "authCompromis": authCompromis,
    "authGDPR": authGDPR,
    "authDretsImatge": authDretsImatge,
    "authSortides": authSortides,
    "authMedica": authMedica,
    "authResponsable": authResponsable,
    "authPortatils": authPortatils,
    "authRecursosDigitals": authRecursosDigitals, // especific
    "authReligio": authReligio, 
  }
  //"authGimnas": authGimnas, // a dades mediques
  //"authIntranet": authIntranet,
  //"authPublicacions": authPublicacions,
  //"authMaterial": authMaterial,
  //"authMaterialInicials": authMaterialInicials,
  //"authInternet": authInternet,
  //"authAMPA": authAMPA,
  //"authAbsentisme": authAbsentisme, //??
  //"authParacetamol": authParacetamol,
  //"authAlternanca": authAlternanca, // cicles

      setDadesAutoritzacions(d)
      props.handleDadesAutoritzacions(d)
    }


  const validaAuthIntranet = () => {
    return authIntranet ? null : "Heu d'indicar una resposta"
  }

  const validaAuthPublicacions= () => {
    return authPublicacions ? null : "Heu d'indicar una resposta"
  }

  const validaAuthMaterial= () => {
    return authMaterial ? null : "Heu d'indicar una resposta"
  }

  const validaAuthMaterialInicials = () => {
    return authMaterialInicials ? null : "Heu d'indicar una resposta"
  }

  const validaAuthDretsImatge = () => {
    //només obligatori pels menors de 14
    //if(props.dadesPersonals.edat >= 14 ) return null
    return authDretsImatge ? null : "Heu d'indicar una resposta"
  }

  const validaAuthReligio= () => {
    return authReligio === "0" ? "Heu d'indicar una opció" : null
  }

  const validaAuthMobils = () => {
    return authRecursosDigitals === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthInternet= () => {
    return authInternet ? null : "Heu d'indicar una resposta"
  }

  const validaAuthCompromis = () => {
    return authCompromis === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthPortatils = () => {
    return authPortatils === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthGDPR= () => {
    return authGDPR === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthResponsable= () => {
    return authResponsable === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthMedica = () => {
    return authMedica === "1" ? null : "Aquest camp és obligatori"
  }

  const validaAuthSortides = () => {
    return authSortides?.length ? null : "Aquest.camp és obligatori. Heu de triar una de les dues opcions"
  }

 const handleChangeCompromis = (t) => {

      setAuthCompromis(t === "0" ? "1" : "0") 

      if(t === "1") handleDadesAutoritzacions(false)
 }

 const handleChangePortatils = (t) => {

      setAuthPortatils(t === "0" ? "1" : "0") 

      handleDadesAutoritzacions(false)
 }

 const handleChangeGDPR = (t) => {

      setAuthGDPR(t === "0" ? "1" : "0") 

      if(t === "1") handleDadesAutoritzacions(false)
 }

 const handleChangeResponsable = (t) => {

      setAuthResponsable(t === "0" ? "1" : "0") 

      if(t === "1") handleDadesAutoritzacions(false)
 }

 const handleChangeSortides = (t) => {

      //setAuthSortides(t === "0" ? "1" : "0") 
      setAuthSortides(t)

      //if(t === "1") handleDadesAutoritzacions(false)
      handleDadesAutoritzacions(false)
 }

 const handleChangeAMPA= (t) => {

      setAuthAMPA(t === "0" ? "1" : "0") 

      if(t === "1") handleDadesAutoritzacions(false)
 }

 const handleChangeMedica= (t) => {

      setAuthMedica(t === "0" ? "1" : "0") 

      if(t === "1") handleDadesAutoritzacions(false)
 }

 const handleChangeParacetamol = (t) => {

      setAuthParacetamol(t === "0" ? "1" : "0") 

      if(t === "1") handleDadesAutoritzacions(false)
 }

 const handleChangeRecursosDigitals = (t) => {

      setAuthRecursosDigitals(t === "0" ? "1" : "0") 

      if(t === "1") handleDadesAutoritzacions(false)
 }

 const handleChangeGimnas = (t) => {

      setAuthGimnas(t === "0" ? "1" : "0") 

      if(t === "1") handleDadesAutoritzacions(false)
 }


 const handleChangeReligio = (t) => {

    if(props.dadesEstudis.authReligio) return true;

    // valor de t: "1" o "2"
     setAuthReligio(t)

     handleDadesAutoritzacions(false)
 }

 const handleChangeAbsentisme = (t) => {

      setAuthAbsentisme(t === "0" ? "1" : "0") 

     handleDadesAutoritzacions(false)
 }

 const handleChangeAlternanca = (t) => {

      setAuthAlternanca(t === "0" ? "1" : "0") 

     handleDadesAutoritzacions(false)
 }




/* VALIDA AUTORITZACIONS */
const validaAutoritzacions = (e) => {
  if(e) e.preventDefault();

  let error = {}

  error.authDretsImatge = validaAuthDretsImatge();
  handleErrors('authDretsImatge', error)

  error.authCompromis = validaAuthCompromis();
  handleErrors('authCompromis',error)

  if(props.dadesEstudis.curs.id.startsWith("ESOLOE") || props.dadesEstudis.curs.id.startsWith("BATXLOE"))
  {
    error.authPortatils = validaAuthPortatils();
    handleErrors('authPortatils',error)
  }

  error.authMedica = validaAuthMedica();
  handleErrors('authMedica',error)

  error.authGDPR = validaAuthGDPR();
  handleErrors('authGDPR',error)


 if(props.dadesPersonals.edat < 18 ){
  error.authSortides= validaAuthSortides();
  handleErrors('authSortides',error)
  }

  error.authResponsable = validaAuthResponsable();
  handleErrors('authResponsable',error)

  if(props.dadesEstudis.curs.id.startsWith("ESOLOE"))
  {
    error.authReligio = validaAuthReligio();
    handleErrors('authReligio',error)
  }

  //error.authRecursosDigitals = validaAuthRecursosDigitals();
  //handleErrors('authRecursosDigitals',error)

  setErrors(error)

  let noError = true;
  //DEVELOP 
  if(!config.develop) // bypass errors if develop == true
  {
    Object.keys(error).map( (k) => { if(error[k] !== null) noError = false } )
  }

  //console.log('ERROR',error,noError);

  handleDadesAutoritzacions(noError)

  if(noError)
  {
     setAuthorizationsOpen(false);
  }

  return noError;
}

  return (
    <div className="container authorizations">
      <div className="row">
        <div className="col col-12 ">
          <div className="t-Region t-Region--hideShow is-expanded t-Region--scrollBody t-Form--noPadding margin-top-sm margin-bottom-none margin-left-none margin-right-none a-Collapsible">
            <div className="t-Region-header">
              <div className="t-Region-headerItems  t-Region-headerItems--controls">
                <button
                  className="t-Button t-Button--icon t-Button--hideShow"
                  type="button"
                  onClick={toggleAuthorizationsOpen}
                >
                  {authorizationsOpen && (
                    <FontAwesomeIcon
                      icon={faChevronUp}
                      fontSize="18"
                      className="t-Icon"
                    />
                  )}
                  {!authorizationsOpen && (
                    <FontAwesomeIcon
                      icon={faChevronDown}
                      fontSize="18"
                      className="t-Icon"
                    />
                  )}
                </button>
              </div>
              <div className="t-Region-headerItems t-Region-headerItems--title">
                <h2 className="t-Region-title a-Collapsible-heading">
                  Protecció de dades i autoritzacions
                </h2>
              </div>
              <div className="t-Region-headerItems t-Region-headerItems--buttons"></div>
            </div>
            <div className="t-Region-bodyWrap">
              <Dropdown open={authorizationsOpen}>
                <div className="t-Region-body a-Collapsible-content">
                  <div className="container">
                    <div className="row">
                      <div className="col col-12 ">
                        <div className="t-Region t-Region--noPadding t-Region--removeHeader t-Region--noBorder t-Region--scrollBody t-Form--noPadding t-Form--leftLabels margin-top-sm">
                          <div className="t-Region-bodyWrap">
                            <div className="t-Region-body">
                              <div className="container">

                                <div className="row">
                                  <div className="col col-12 ">
                                    <h4>
                                    Carta de compromís educatiu. Curs {props.enguany}-{props.anyVinent}
                                    </h4>

                                      <p>La carta de compromís educatiu és un document que té com a finalitat potenciar la comunicació, la participació, la implicació, el compromís i la coresponsabilitat entre els centres i les famílies en l'educació d'infants i joves. Aquesta carta té per objectius principals, entre d'altres:</p>

                                      <ol>
                                        <li> Compartir amb les famílies els principis i els continguts del projecte educatiu del centre i, si escau, els projectes educatius de l'entorn.</li>
                                        <li> Millorar la informació i la comunicació entre el centre i les famílies.</li>
                                        <li> Facilitar a les famílies l'exercici dels seus drets i el compliment dels deures.</li>
                                        <li> Fomentar la convivència i el bon clima escolar.</li>
                                        <li> Coresponsabilitzar el centre i la família en l'èxit acadèmic, personal i social dels alumnes i també en el compromís cívic dels infants i joves.</li>
                                      </ol>

                                      <p>El centre, les famílies i l'alumnat signem aquest document i ens comprometem amb les mesures i recomanacions aquí subscrites per millorar així el clima escolar, la comunicació i els resultats acadèmics de l'alumnat,</p>

                                      <br/>

                                    <h5>
                                    Per part del centre:
                                    </h5>

                                      <b>Informacions i comunicacions</b>
                                      <ul>
                                        <li> Informar la família del projecte educatiu i de les normes d’organització, funcionament i convivència del Centre.</li>
                                        <li> Concertar una reunió a començament de curs i, com a mínim, una entrevista anual amb el tutor/a.</li>
                                        <li> Convocar la família sempre que el Centre ho consideri necessari.</li>
                                      </ul>

                                      <b>Seguiment acadèmic de l'alumne/a</b>
                                      <ul>
                                        <li> Notificar els resultats acadèmics i les informacions necessàries de l'evolució acadèmica i personal de l'alumne/a.</li>
                                        <li>Adoptar les mesures adients per atendre les necessitats específiques de l'alumne/a i mantenir-ne informada la família.</li>
                                        <li>Donar orientació de caràcter personal i acadèmic a l'alumne/a en acabar l'ESO.</li>
                                      </ul>

                                      <b>Convivència en el Centre</b>
                                      <ul>
                                        <li>Facilitar la formació integral de l'alumne/a, tant pel que fa als continguts acadèmics, com pel que fa a les actituds i valors cívics i ètics per viure en societat.</li>
                                        <li>Vetllar per fer efectius els drets de l'alumne/a en el Centre.</li>
                                        <li>Respectar les conviccions de la família dins el marc legal i protegir la intimitat de l'alumne/a.</li>
                                        <li>Comunicar a la família les incidències originades diàriament.</li>
                                          <li>Informar la família de les normes d’organització i funcionament del centre (NOFC), relatives als acords de centre sobre l’ús dels telèfons mòbils:<br/>
                                            ➢​ Amb caràcter general, no està permès l’ús de telèfons mòbils a l’alumnat d’ESO.  L’alumne/a que porti un dispositiu mòbil personal l’ha d’apagar en entrar al centre i ha de garantir que resti apagat de manera que no es pugui accedir a les dades personals que el dispositiu emmagatzema. S’estableix, la prohibició de l’ús generalitzat en tots els espais del centre. En les activitats educatives fora del centre es valorarà si es permet o no l’ús del mòbil</li>
                                      </ul>

                                      <b>Seguiment dels acords</b>
                                      <ul>
                                        <li>Revisar conjuntament amb la família el contingut i el compliment d'aquests compromisos, si s'escau.</li>
                                      </ul>

                                      <br/>

                                    <h5>
                                    Per part de la família:
                                    </h5>
                                    <b>Informacions i comunicacions</b>
                                    <ul>
                                    <li> Llegir, acceptar i respectar les normes d'organització, funcionament i convivència del Centre (NOFC).</li>
                                    <li> Informar correctament de l'adreça, telèfons i, si s'escau, correu electrònic, i comunicar tots els canvis que es puguin anar produint durant el curs.</li>
                                    <li> Assistir a les reunions convocades pel Centre i retornar signats els comunicats oficials.</li>
                                    </ul>

                                    <b>Seguiment acadèmic de l'alumne/a</b>
                                    <ul>
                                    <li> Vetllar perquè el fill o la filla compleixi els drets i deures que comportem forma part de la Comunitat Educativa.</li>
                                    <li> Tenir cura de que el fill o la filla disposi de les eines i recursos necessaris pel tal de complimentar el seu desenvolupament acadèmic i personal.</li>
                                    <li> Facilitar al Centre les informacions considerades rellevants per al procés educatiu de l’alumne/a.</li>
                                    </ul>

                                    <b>Convivència en el Centre</b>
                                    <ul>
                                    <li> Respectar el caràcter propi del Centre i reconèixer l'autoritat del seu òrgan directiu i la resta de membres que configuren la Comunitat educativa.</li>
                                    <li> Instar els alumnes a respectar les normes específiques de funcionament del Centre, principalment les que afecten la convivència escolar i organització del Centre.</li>
                                    <li> Vetllar perquè l’alumnat assisteixi regularment i puntualment a classe i avisar al Centre en cas d'absència o retard justificat.</li>
                                    <li> Adreçar-se al Centre, seguint els canals més adequats en cada cas (professorat, tutor/a, coordinació i direcció).</li>
                                    <li> Respectar les normes d’organització i funcionament del centre (NOFC) en relació la regulació dels telèfons mòbils.</li>
                                    </ul>

                                    <b>Seguiment dels acords</b>
                                    <ul>
                                    <li> Revisar conjuntament amb el Centre educatiu el contingut i el compliment d'aquests compromisos, si s'escau.  </li> 
                                    </ul>


                                    <p>
                                      <input type="checkbox" id="authCompromis" name="authCompromis" value={authCompromis} checked={authCompromis === "1" ? true : false } onChange={ (t) => { handleChangeCompromis(t.target.value) } } required/>
                                       <label htmlFor='authCompromis'>
                                        He llegit i accepto la carta de compromís educatiu 
                                        </label>
                                      <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authCompromis}</span>
                                    </p>

                                  </div>
                                </div>


<br/>
<br/>
                                <div className="row">
                                  <div className="col col-12 ">
                                    <h4>
                                       Drets d’imatge. Curs {props.enguany}-{props.anyVinent}
                                    </h4>
                                    <p>
                                      AUTORITZO que la imatge del meu fill/a, pugui aparèixer en fotografies, vídeos, pàgines web i altres mitjans, corresponents a activitats escolars lectives, complementàries i extraescolars, de l’Institut i/o l’AMPA.
                                    </p>
                                  </div>
                                </div>

                                <div className="row">
                                  <div className="col col-12 ">
                                    <FormSelectYesNo
                                      id="authDretsImatge"
                                      name="authDretsImatge"
                                      col="col-4"
                                      label="Drets d'Imatge:"
                                      obligatori={true}
                                      value={authDretsImatge}
                                      handleChange={(e) => setAuthDretsImatge(e.target.value) }
                                      error={errors.authDretsImatge}
                                    />
                                </div>
                               </div>
                                      <br/>

                                <div className="row">
                                  <div className="col col-12 ">
                                    <h4>
                                      Informació bàsica sobre protecció de dades
                                    </h4>
                                    <p>
                                      <b>Responsable del tractament:</b> Direcció del centre educatiu.<br/>
                                      <b>Finalitat:</b> Autorització difusió d’imatge/veu i material elaborat als espais de comunicació i difusió del centre.<br/>
                                      <b>Legitimació:</b> Consentiment de l’interessat o de la persona que ostenta la tutoria legal en cas de menors d’edat.<br/>
                                      <b>Destinataris:</b> Les dades no es comunicaran a tercers, excepte en els casos previstos per llei, o si ho heu consentit
                                      prèviament.<br />
                                      <b>Drets:</b> Accedir a les dades, rectificar-les, suprimir-les, oposar-se al tractament i sol·licitar-ne la limitació.<br />
                                      <b>Informació addicional:</b> Podeu consultar la informació addicional i detallada sobre protecció de dades a la pàgina:
                                    </p>
                                      <ul>
                                        <li><a href="https://educacio.gencat.cat/ca/Detall/alumnes-centres-departament" target="_blank">https://educacio.gencat.cat/ca/Detall/alumnes-centres-departament</a> </li>
                                        <li><a href="https://educacio.gencat.cat/ca/Detall/personal-centres-departament" target="_blank">https://educacio.gencat.cat/ca/Detall/personal-centres-departament</a></li>
                                      </ul>
                                    <br/>



                                    <p>
                                      <input type="checkbox" id="authGDPR" name="authGDPR" value={authGDPR} checked={authGDPR === "1" ? true : false } onChange={ (t) => { handleChangeGDPR(t.target.value) } } required/>
                                      <label htmlFor="authGDPR">He llegit la informació bàsica sobre protecció de dades i autoritzo el tractament de les meves dades personals.</label>
                                      <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authGDPR}</span>
                                    </p>

                                  </div>
                                </div>

                                      <br/>

                                { props.dadesPersonals.edat < 18 && (
                                  <div className="row">
                                  <div className="col col-12 ">
                                    <h4>
                                    Autorització de sortides pedagògiques dins del municipi de Martorell
                                    </h4>
                                    <p>
                                      <input type="radio" id="authSortides1" name="authSortides" value={authSortides} checked={authSortides === "1" ? true : false } onChange={ (t) => { handleChangeSortides("1") } } required/>
                                      <label htmlFor="authSortides1">
                                        AUTORITZO al meu fill/a a participar a totes les sortides pedagògiques que es realitzin dins la localitat de Martorell, proposades pels departaments didàctics del centre i aprovades pel Consell Escolar.
                                          </label>
                                      <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authSortides}</span>

                                      <br/>

                                      <input type="radio" id="authSortides0" name="authSortides" value={authSortides} checked={authSortides === "0" ? true : false } onChange={ (t) => { handleChangeSortides("0") } } required/>
                                      <label htmlFor="authSortides0">
                                       <b>NO</b> AUTORITZO al meu fill/a a participar a totes les sortides pedagògiques que es realitzin dins la localitat de Martorell, proposades pels departaments didàctics del centre i aprovades pel Consell Escolar.
                                          </label>
                                      <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authSortides}</span>
                                    </p>

                                  </div>
                                </div>)}

                                      <br/>

                                  <div className="row">
                                  <div className="col col-12 ">
                                    <h4>
                                    Autorització mèdica
                                    </h4>
                                    <p>
                                      <input type="checkbox" id="authMedica" name="authMedica" value={authMedica} checked={authMedica === "1" ? true : false } onChange={ (t) => { handleChangeMedica(t.target.value) } } required/>
                                      <label htmlFor="authMedica"> AUTORITZO en cas que es produís una urgència mèdica imprevista greu i l’Institut l’hagués d’acompanyar a un centre mèdic, mentre no arriba la família, autoritzo el professor acompanyant a prendre totes les decisions oportunes (proves, anàlisis, transfusions ...). </label>
                                      <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authMedica}</span>
                                    </p>


                                  </div>
                                </div>

                                      <br/>

                                    {/* 
                                  <div className="row">
                                  <div className="col col-12 ">
                                    <h4>
                                    Autorització per a l’administració de paracetamol
                                    </h4>
                                    <p>
                                      <input type="checkbox" id="authParacetamol" name="authParacetamol" value={authParacetamol} checked={authParacetamol === "1" ? true : false } onChange={ (t) => { handleChangeParacetamol(t.target.value) } } required/>
                                      <label htmlFor="authParacetamol"> AUTORITZO  El centre educatiu a administrar paracetamol al meu fill/a, en cas de presentar febre superior a 38℃ de temperatura corporal mentre s’espera l’arribada d’algun familiar que el pugui portar a casa. </label>
                                      <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authParacetamol}</span>
                                    </p>

                                  </div>
                                </div>

                                      <br/>
                                      */}

                                    {/*<div className="row">
                                      <div className="col col-12 ">
                                        <h4>
                                          Autorització per a activitats esportives
                                        </h4>
                                        <p>
                                          Jo, com a responsable legal que soc d’ell/ella, he fet tot el que calia per conèixer el seu estat de salut; per tant, <br/><br/>
                                          <input type="checkbox" id="authGimnas" name="authGimnas" value={authGimnas} checked={authGimnas === "1" ? true : false} onChange={(t) => { handleChangeGimnas(t.target.value) }} required />
                                          <label htmlFor="authGimnas"> AUTORITZO que faci els exercicis de gimnàstica i les activitats esportives pròpies de la seva edat (exempta, si és el cas, les que s’indiquen en el certificat mèdic oficial que us adjunto).  </label>
                                          <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authGimnas}</span>
                                        </p>

                                      </div>
                                    </div>

                                <br />*/}




                                {/* RECURSOS DIGITALS */}

                                {/* MENORS 14*/}
                                { props.dadesPersonals.edat < 14 ? (
                              <div className="row">
                              <div className="col col-12 ">
                                <h4>
                                  Autorització relativa als alumnes de menys de 14 anys: ús de serveis i recursos digitals a Internet per treballar a l’aula
                                </h4>
                                <p>


                                  <input type="checkbox" id="authRecursosDigitals" name="authRecursosDigitals" value={authRecursosDigitals} checked={authRecursosDigitals === "1" ? true : false } onChange={ (t) => { handleChangeRecursosDigitals(t.target.value) } } required/>
                                  <label htmlFor="authRecursosDigitals"> 
                                    AUTORITZO, que que el meu fill/a utilitzi, per al treball acadèmic, els serveis telemàtics i/o aplicacions de dispositius mòbils que requereixen usuari i contrasenya, els quals s’especifiquen a continuació: Creació i gestió de l'usuari i contrasenya corporativa (G-Suite), Plataformes digitals
(Moodle, Classroom...)
                                    </label>
                                    <small>La responsabilitat de l’ús que se’n faci en l’àmbit escolar correspon al centre educatiu. El centre no es fa responsable, però, de l’ús indegut del recurs i dels continguts per part dels usuaris: l’usuari serà l’únic responsable de les infraccions en què pugui incórrer o dels perjudicis que pugui causar per un ús inadequat dels serveis o dels continguts.</small>
                                  <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authRecursosDigitals}</span>
                                </p>


                              </div>
                            </div>
                                ):
                                (<> {/* ENTRE 14 i 18*/}
                                { props.dadesPersonals.edat < 18 ? (
                                      <div className="row">
                                        <div className="col col-12 ">
                                          <h4>
                                            Comunicació relativa als alumnes de més de 14 anys però menors d’edat: ús de serveis i recursos digitals a Internet per treballar a l’aula
                                          </h4>
                                          <p>


                                            <input type="checkbox" id="authRecursosDigitals" name="authRecursosDigitals" value={authRecursosDigitals} checked={authRecursosDigitals === "1" ? true : false} onChange={(t) => { handleChangeRecursosDigitals(t.target.value) }} required />
                                            <label htmlFor="authRecursosDigitals">
                                              Estic assabentat/ada que utilitzaré, per al treball acadèmic, els serveis telemàtics i/o aplicacions de dispositius mòbils que
                                              requereixen usuari i contrasenya que s’especifiquen a continuació: reació i gestió de l'usuari i contrasenya corporativa (G-Suite), Plataformes digitals (Moodle, Classroom...)
                                            </label>
                                            <small>La responsabilitat de l’ús que se’n faci en l’àmbit escolar correspon al centre educatiu. El centre no es fa responsable, però, de l’ús indegut del recurs i dels continguts per part dels usuaris: l’usuari serà l’únic responsable de les infraccions en què pugui incórrer o dels perjudicis que pugui causar per un ús inadequat dels serveis o dels continguts.</small>
                                            <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authRecursosDigitals}</span>
                                          </p>


                                        </div>
                                      </div>
                                ):
                                (<> {/* MAJORS EDAT*/}
                                      <div className="row">
                                        <div className="col col-12 ">
                                          <h4>Comunicació relativa als alumnes majors d'edat i als professors i personal del centre: ús de serveis i recursos digitals a Internet per treballar a l’aula.  </h4>
                                          <p>

                                            <input type="checkbox" id="authRecursosDigitals" name="authRecursosDigitals" value={authRecursosDigitals} checked={authRecursosDigitals === "1" ? true : false} onChange={(t) => { handleChangeRecursosDigitals(t.target.value) }} required />
                                            <label htmlFor="authRecursosDigitals"> Estic assabentat/ada que utilitzaré, per al treball acadèmic, els serveis telemàtics i/o aplicacions de dispositius mòbils que
                                              requereixen usuari i contrasenya que s’especifiquen a continuació: reació i gestió de l'usuari i contrasenya corporativa (G-Suite), Plataformes digitals (Moodle, Classroom...)
                                            </label>
                                            <small>La responsabilitat de l’ús que se’n faci en l’àmbit escolar correspon al centre educatiu. El centre no es fa responsable, però, de l’ús indegut del recurs i dels continguts per part dels usuaris: l’usuari serà l’únic responsable de les infraccions en què pugui incórrer o dels perjudicis que pugui causar per un ús inadequat dels serveis o dels continguts.</small>
                                            <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authRecursosDigitals}</span>
                                          </p>


                                        </div>
                                      </div>
                                
                                
                                
                                
                                
                                
                                
                                
                                </>)
                                }



                                
                                
                                
                                
                                
                                
                                
                                </>)
                                }

                                    <br />

                                {/* AUTORITZACIONS ESPECIFIQUES ESO */}
                                {/*props.dadesEstudis.curs.id.startsWith("ESOLOE") && (<>

                                    <div className="row">
                                      <div className="col col-12 ">
                                        <h4>
                                          Declaració sobre l'opció per la formació religiosa o valors
                                        </h4>

                                        <p>Aquesta elecció és vàlida durant tota l’etapa educativa d’ESO. En cas de canvi, en finalitzar el curs, s’ha de comunicar a la
Secretaria del centre per a que aquest canvi tingui efectes el curs vinent.</p><br/>

                                          <label>
                                            <input type="radio" id="authReligio" name="authReligio" value={authReligio} checked={authReligio === "1" ? true : false} disabled onChange={(t) => { handleChangeReligio("1") }} required /> DESITGEM que el/la nostre/a fill/a rebi FORMACIÓ RELIGIOSA: CATÒLICA
                                            </label>

                                          <br />

                                          <label> 
                                           <input type="radio" id="authReligio" name="authReligio" value={authReligio} checked={authReligio === "2" ? true : false} disabled onChange={(t) => { handleChangeReligio("2") }} required /> DESITGEM que el/la nostre/a fill/a rebi ENSENYAMENT DE: VALORS
                                          </label>

                                          <span id="auhtReligio_ERROR" className="a-Form-error">{errors.authReligio}</span>

                                      </div>
                                    </div>

                                    <br />
                                  </>
                                )*/}

                                {/* AUTORITZACIONS ESPECIFIQUES ESO i BATX */}
                                { ( props.dadesEstudis.curs.id.startsWith("ESOLOE") || props.dadesEstudis.curs.id.startsWith("BATXLOE")) && (<>
                              <div className="row">
                              <div className="col col-12 ">
                                <h4>
                                Condicions de recepció de l'ordinador portàtil
                                </h4>
                                <p>

                                En el marc del Pla d’educació digital de Catalunya, el Projecte d’acceleració de la
                                transformació digital desplega com una de les intervencions dotar d’equipaments
                                l’alumnat dels centres. L’institut Pompeu Fabra lliurarà als alumnes d ́ESO i Batxillerat un
                                ordinador amb les següents característiques: <br/>
                                                                  <br/>

                                    <div className="quadrePortatilAutoritzacions">
                                        Lenovo, 11,6”
                                    </div>

                                                                  <br/>

                                Des del centre es posa a la teva disposició aquest aparell perquè en facis el bon ús
                                necessari per al teu aprenentatge. És responsabilitat teva assegurar-te que es va
                                mantenir en bon estat, conscient que hauràs de tornar-la al final del curs o del teu
                                període d'escolarització a l'institut Cavall Bernat.
                                Recordeu, aquest ordinador no és de la vostra propietat, sinó que l'institut et deixa en
                                préstec.  <br/>


                                  Compromísos:<br/>

                                  <ol>
                                        <li>Portar l'ordinador al centre sempre, per poder treballar adequadament o per revisar-lo.</li> 
                                        <li> Portar l'ordinador carregat de casa. És necessari utilitzar el carregador corresponent a l'ordinador i no cap altre.</li> 
                                        <li> No marcar-lo, ratllar-lo o personalitzar-lo. Cal mantenir la identificació amb un etiquetatge discret que es pugui extreure quan es torni.</li> 
                                        <li> Tornar l'ordinador en perfecte estat al final de la teva escolarització al centre. En concret, heu d'incloure qualsevol accessori que s'hagi facilitat juntament amb l'aparell (adaptador, carregador, etc.). Cal que estigui net, lliure de pols, esquitxades, empremtes,etc.</li> 
                                        <li> La pèrdua de l'ordinador, el carregador o qualsevol trencament es considera una falta greu, amb la conseqüent sanció disciplinària i econòmica.</li> 
                                        <li> Si es detecta qualsevol mal ús, es retirarà l'ordinador. El seu ús és acadèmic, no pas per altres possibilitats fora de les indicacions específiques dels docents.</li> 
                                  </ol>

                                  <input type="checkbox" id="authPortatils" name="authPortatils" value={authPortatils} checked={authPortatils === "1" ? true : false } onChange={ (t) => { handleChangePortatils(t.target.value) } } required/>
                                  <label htmlFor="authPortatils"> He llegit i accepto la normativa</label>
                                  <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authPortatils}</span>
                                </p>


                              </div>
                            </div>

                                  <br/>
                                  </>
                                )}

                                {/* AUTORITZACIONS ESPECIFIQUES 3r i 4t ESO 
                                { (props.dadesEstudis.curs.id === "ESOLOE03" 
                                    || props.dadesEstudis.curs.id === "ESOLOE04"
                                    || props.dadesEstudis.curs.id.startsWith("BATXLOE")
                                    
                                    ) && (<>
                                
                                  <div className="row">
                                  <div className="col col-12 ">
                                    <h4>
                                    Autorització de cessió de dades per a l'orientació en situacions d'absentisme i abandonament d'estudis
                                    </h4>
                                    <p>
                                    (Els majors de 14 anys no necessiten l'autorització del pare, mare o representant legal.)<br/>

                                      Per millorar l'orientació educativa de l'alumnat, el Departament d'Educació sol-licita l'autorització per
                                      comunicar determinades dades personals dels alumnes a l'Administració local i a l'Administració
                                      educativa, que ofereixen un servei d'orientació per donar noves oportunitats als estudiants que es
                                      troben en situació d'absentisme o decideixen abandonar els estudis iniciats, per motius diversos.
                                      Les dades que es poden comunicar són les identificatives i de contacte, nacionalitat, sexe, mes i any de
                                      naixement, i de matrícula i nivell d'ensenyament dels alumnes.
                                    </p>

                                      <input type="checkbox" id="authAbsentisme" name="authAbsentisme" value={authAbsentisme} checked={authAbsentisme === "1" ? true : false } onChange={ (t) => { handleChangeAbsentisme(t.target.value) } } required/>
                                      <label htmlFor="authAbsentisme"> AUTORITZO  el Departament d'Educació a comunicar les dades personals indicades a l'Administració local i l'Administració educativa, exclusivament per gestionar els processos d'acompanyament, orientació, suport i assessorament en les situacions d'absentisme o abandonament d'estudis.  </label>
                                      <span id="auhtAbsentisme_ERROR" className="a-Form-error">{errors.authAbsentisme}</span>

                                    <br />
                                    <p>
                                        <i>Aquesta autorització té validesa durant els pròxims 10 anys o fins que l'alumne/a compleixi 24 anys.  Podeu retirar el vostre consentiment en qualsevol moment.</i>
                                    </p>

                                  </div>
                                </div>
                                
                                    <br />
                                </>)
                                }
                                      */}


                                  {/*
                                  <div className="row">
                                  <div className="col col-12 ">
                                    <h4>
                                    Autorització cessió del correu electrònic a l’AMPA
                                    </h4>
                                    <p>
                                      <input type="checkbox" id="authAMPA" name="authAMPA" value={authAMPA} checked={authAMPA === "1" ? true : false } onChange={ (t) => { handleChangeAMPA(t.target.value) } } required/>
                                      <label htmlFor="authAMPA"> AUTORITZO que el centre faliciti el meu correu electrònic a l’AMPA per poder rebre informació </label>
                                      <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authAMPA}</span>
                                    </p>

                                  </div>
                                </div>

                                      <br/>*/}

                                <div className="row">
                                  <div className="col col-12 ">
                                    <h4>
                                      Declaració responsable de veracitat de les dades aportades i acceptació
                                    </h4>
                                    <p>
                                      <input type="checkbox" id="authResponsable" name="authResponsable" value={authResponsable} checked={authResponsable === "1" ? true : false } onChange={ (t) => { handleChangeResponsable(t.target.value) } } required/>
                                      <label htmlFor="authResponsable">Declaro que totes les dades aportades en aquest procediment són certes i la possibilitat d’acreditar documentalment totes les dades esmentades anteriorment, en cas que se m’exigeixin.  Que aquestes autoritzacions tindran vigència durant l’escolarització de l’alumne/a al centre.</label>
                                      <span id="auhtMaterial_ERROR" className="a-Form-error">{errors.authResponsable}</span>
                                    </p>

                                  </div>
                                </div>



                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="container">
                            <div className="row">
                              <div className="col col-12" align="center">
                                <button onClick={validaAutoritzacions} className="button">SEGÜENT</button>
                              </div>
                            </div>
                          </div>

                </div>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}